import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import OneTimeSharingLogo from "./assets/logo.png";
import CloudwayLogo from "./assets/cloudway-logo.png";

import OneClickIcon from "./assets/oneclickicon.svg?react";
import PKIIcon from "./assets/pkiicon.svg?react";
import KeyIcon from "./assets/keypairicon.svg?react";

const Navigation = () => {
	const navigate = useNavigate();

	return (
		<Container>
			<div className="flex flex-col items-center justify-center gap-[40px] pt-[34px] w-full h-full bg-[rgba(0,123,236,0.1)]">
				<img className="h-[40px]" src={OneTimeSharingLogo} />
				<div className="flex flex-col gap-[20px] max-w-[600px] w-full px-[10px]">
					<div className="flex flex-wrap gap-[20px]">
						<button
							className="w-full mx-auto max-w-[278px] h-[120px] bg-white rounded-md shadow border border-stone-300 flex justify-center items-center gap-[12px] cursor-pointer"
							onClick={() => {
								navigate("/encryptshe");
							}}
						>
							<OneClickIcon />
							OneClick sharing
						</button>
						<button
							className="w-full mx-auto max-w-[278px] h-[120px] bg-white rounded-md shadow border border-stone-300 flex justify-center items-center gap-[12px] cursor-pointer"
							onClick={() => {
								navigate("/encrypt");
							}}
						>
							<PKIIcon />
							PGP encryption
						</button>
					</div>
					<button
						className="w-full h-[120px] bg-white rounded-md shadow border border-stone-300 flex justify-center items-center gap-[12px] cursor-pointer"
						onClick={() => {
							navigate("/keygenerator");
						}}
					>
						<KeyIcon />
						Key Generator
					</button>
				<a className="flex items-center justify-center gap-[10px]" href="https://cloudway.be/">Powered by <img className="h-5" src={CloudwayLogo} /></a>
				</div>
			</div>
		</Container>
	);
};

export default Navigation;

const Container = styled.div`
	width: 100vw;
	height: 100vh;

	overflow: auto;

	textarea {
		outline: none;
	}

	input {
		outline: none;
	}
`;
